import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

function Box({ accent, title, children }) {
  return (
    <div className="border rounded-lg p-4 mb-3" style={{ borderColor: "#e2e8f0" }}>
      <div className="flex items-center gap-2 mb-2">
        <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: accent }} />
        <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>{title}</h2>
      </div>
      {children}
    </div>
  );
}

export default function BoxedModernTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-snug" data-testid="resume-live-preview">
      <div className="mb-4">
        <h1 className="text-2xl font-bold" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        <p className="text-slate-500 text-xs mt-0.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
        {draft.target_role && <p className="text-slate-600 text-xs mt-0.5 font-semibold">{draft.target_role}</p>}
      </div>
      {draft.summary && <Box accent={accent} title="Summary"><p className="text-slate-700">{draft.summary}</p></Box>}
      {draft.experience.length > 0 && (
        <Box accent={accent} title="Experience">
          {draft.experience.map((e, i) => (
            <div key={i} className={i > 0 ? "mt-2" : ""}>
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </Box>
      )}
      <div className="grid grid-cols-2 gap-3">
        {draft.education.length > 0 && (
          <Box accent={accent} title="Education">
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 text-[12px]">{ed.degree} {ed.field}<br /><span className="text-slate-500">{ed.school}</span></p>)}
          </Box>
        )}
        {draft.skills.length > 0 && (
          <Box accent={accent} title="Skills">
            <div className="flex flex-wrap gap-1">{draft.skills.map((sk) => <span key={sk} className="text-[10px] font-medium px-1.5 py-0.5 rounded" style={{ backgroundColor: `${accent}12`, color: accent }}>{sk}</span>)}</div>
          </Box>
        )}
      </div>
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
